import { TypeTdCustomPageRadioTileFields } from 'app/services/contentful/models/TypeTdCustomPageRadioTile'
import { ActivityHistoryScene } from 'components/product-ui/scenes/activity-history'
import { AddTasksSubTasks } from 'components/product-ui/scenes/add-tasks-sub-tasks'
import { AdminControlsScene } from 'components/product-ui/scenes/admin-controls'
import { AdvancedPermissionsScene } from 'components/product-ui/scenes/advanced-permissions'
import { AssignResponsibility } from 'components/product-ui/scenes/assign-responsibility'
import { AssignedTasksScene } from 'components/product-ui/scenes/assigned-tasks'
import { CalendarViews } from 'components/product-ui/scenes/calendar-views'
import { CommentShareFiles } from 'components/product-ui/scenes/comment-share-files'
import { CommentsScene } from 'components/product-ui/scenes/comments'
import { CompletedTasksScene } from 'components/product-ui/scenes/completed-tasks'
import { CustomSharedTemplatesScene } from 'components/product-ui/scenes/custom-shared-templates'
import { CustomTemplates } from 'components/product-ui/scenes/custom-templates'
import { FilterByTeamOrPersonalProjectScene } from 'components/product-ui/scenes/filter-by-team-or-personal-projects'
import { FiltersScene } from 'components/product-ui/scenes/filters'
import { FreeProFeatures } from 'components/product-ui/scenes/free-pro-features'
import { GroupFilterTasks } from 'components/product-ui/scenes/group-filter-tasks'
import { HolisticDailyViews } from 'components/product-ui/scenes/holistic-daily-views'
import { KarmaScene } from 'components/product-ui/scenes/karma'
import { LabelsScene } from 'components/product-ui/scenes/labels'
import { PersonalMeansPrivate } from 'components/product-ui/scenes/personal-means-private'
import { PreviewProjectsScene } from 'components/product-ui/scenes/preview-projects'
import { PrioritiesScene } from 'components/product-ui/scenes/priorities'
import { ProductivityVisualizationsScene } from 'components/product-ui/scenes/productivity-visualizations'
import { ProjectFolders } from 'components/product-ui/scenes/project-folders'
import { ProjectLayouts } from 'components/product-ui/scenes/project-layouts'
import { ProjectSharingScene } from 'components/product-ui/scenes/project-sharing'
import { ProjectsScene } from 'components/product-ui/scenes/projects'
import { PublicPrivateTeamProjectsScene } from 'components/product-ui/scenes/public-private-team-projects'
import { QuickAddScene } from 'components/product-ui/scenes/quick-add'
import { QuickAddTasksScene } from 'components/product-ui/scenes/quick-add-tasks'
import { RecurringDueDatesScene } from 'components/product-ui/scenes/recurring-due-dates'
import { RemindersScene } from 'components/product-ui/scenes/reminders'
import { RestrictedProjects } from 'components/product-ui/scenes/restricted-projects'
import { SectionsSubtasksScene } from 'components/product-ui/scenes/sections-subtasks'
import { SetDueDates } from 'components/product-ui/scenes/set-due-dates'
import { SharedCustomLabels } from 'components/product-ui/scenes/shared-custom-labels'
import { SharedProjectsScene } from 'components/product-ui/scenes/shared-projects'
import { SimpleDataSeparation } from 'components/product-ui/scenes/simple-data-separation'
import { TaskDescriptionsScene } from 'components/product-ui/scenes/task-descriptions'
import { TeamActivityScene } from 'components/product-ui/scenes/team-activity'
import { TemplatesScene } from 'components/product-ui/scenes/templates'
import { TodayViewScene } from 'components/product-ui/scenes/today-view'
import { UpcomingViewScene } from 'components/product-ui/scenes/upcoming-view'
import { ViewJoinCreateProjects } from 'components/product-ui/scenes/view-join-create-projects'
import { WorkspacesScene } from 'components/product-ui/scenes/workspaces'
import { FlexibleViewsSequence } from 'components/product-ui/sequences/flexible-views-sequence/flexible-views-sequence'
import { GetItAllDoneSequence } from 'components/product-ui/sequences/get-it-all-done-sequence/get-it-all-done-sequence'
import { QuickAddSequence } from 'components/product-ui/sequences/quick-add-sequence/quick-add-sequence'
import { SimplifyPlanningSequence } from 'components/product-ui/sequences/simplify-planning-sequence/simplify-planning-sequence'
import { TodayViewSequence } from 'components/product-ui/sequences/today-view-sequence/today-view-sequence'

const allScenes: Record<
    Exclude<TypeTdCustomPageRadioTileFields['sceneName']['values'], 'StaticImage'>,
    JSX.Element
> = {
    FlexibleViewsSequence: <FlexibleViewsSequence />,
    GetItAllDoneSequence: <GetItAllDoneSequence />,
    QuickAddSequence: <QuickAddSequence />,
    TodayViewSequence: <TodayViewSequence />,
    SimplifyPlanningSequence: <SimplifyPlanningSequence />,
    ActivityHistory: <ActivityHistoryScene />,
    AddTasksSubTasks: <AddTasksSubTasks />,
    AdminControls: <AdminControlsScene />,
    AdvancedPermissions: <AdvancedPermissionsScene />,
    AssignResponsibility: <AssignResponsibility />,
    AssignedTasks: <AssignedTasksScene />,
    CalendarViews: <CalendarViews />,
    CommentShareFiles: <CommentShareFiles />,
    Comments: <CommentsScene />,
    CompletedTasks: <CompletedTasksScene />,
    CustomAndSharedTemplates: <CustomSharedTemplatesScene />,
    CustomTemplates: <CustomTemplates />,
    FilterByTeamOrPersonalProjects: <FilterByTeamOrPersonalProjectScene />,
    Filters: <FiltersScene />,
    FreeProFeatures: <FreeProFeatures />,
    GroupFilterTasks: <GroupFilterTasks />,
    HolisticDailyViews: <HolisticDailyViews />,
    Karma: <KarmaScene />,
    Labels: <LabelsScene />,
    PersonalMeansPrivate: <PersonalMeansPrivate />,
    PreviewProjects: <PreviewProjectsScene />,
    Priorities: <PrioritiesScene />,
    ProductivityVisualization: <ProductivityVisualizationsScene />,
    ProjectFolders: <ProjectFolders />,
    ProjectLayout: <ProjectLayouts />,
    ProjectSharing: <ProjectSharingScene />,
    Projects: <ProjectsScene />,
    PublicOrPrivateTeamProjects: <PublicPrivateTeamProjectsScene />,
    QuickAdd: <QuickAddScene />,
    QuickAddTasks: <QuickAddTasksScene />,
    RecurringDueDates: <RecurringDueDatesScene />,
    Reminders: <RemindersScene />,
    RestrictedProjects: <RestrictedProjects />,
    SectionsSubtasks: <SectionsSubtasksScene />,
    SetDueDates: <SetDueDates />,
    SharedCustomLabels: <SharedCustomLabels />,
    SharedProjects: <SharedProjectsScene />,
    SimpleDataSeparation: <SimpleDataSeparation />,
    TaskDescription: <TaskDescriptionsScene />,
    TeamActivity: <TeamActivityScene />,
    Templates: <TemplatesScene />,
    TodayView: <TodayViewScene />,
    UpcomingView: <UpcomingViewScene />,
    ViewJoinCreateProjects: <ViewJoinCreateProjects />,
    Workspaces: <WorkspacesScene />,
} as const

type SceneName = keyof typeof allScenes

export { allScenes }
export type { SceneName }
